import React, { useContext, useState } from "react";
import Swal from "sweetalert2";

// import imagenes
import carroIcono from "../../../assets/img/camion-disponible.png";
import saveIcono from "../../../assets/img/camion-en-revision.png";
import viajeCreado from "../../../assets/img/salida-programada.png";
import CajaTp from "../../../assets/img/camion-en-revision.png";

import { AuthContext } from "../../../context/authContext/authContext";
import { TarjetaAperturaUnidad } from "./TarjetaAperturaUnidad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { GestionEventoRoboCamionesModal } from "../../customComponents/Modals/GestionEventoRoboCamionesModal";

export const TarjetaUnidades = ({
  status_id,
  selectUnidad,
  unidad_id,
  unidad_numero,
  cat_tipos_almacen,
  cedi,
  spot,
  nombre_transportadora,
  unidad,
  status,
  comandos,
  tipo_unidad_id,
}) => {

  if (cedi === null) {
    cedi = {
      flujo_id: 1,
      nombre_cedis: "",
    };
  }

  const { user } = useContext(AuthContext);
  const [actiModal, setActiModal] = useState(false);
  const modalClose = () => setActiModal(false);
  const [unidadSeleccionada, setUnidadSeleccionada] = useState();
  const [eventAction, setEventAction] = useState("REGISTRAR");

  const pintarMotivoDenegacion = (viajes) => {
    if (viajes && viajes.length > 0) {
      if (
        viajes[0].denegaciones_viajes &&
        viajes[0].denegaciones_viajes.length > 0
      ) {
        return (
          <>
            <h5 className="mb-0 text-uppercase" style={{ fontWeight: 900 }}>
              ({viajes[0].denegaciones_viajes[0].comentario})
            </h5>
          </>
        );
      } else {
        return "(S/D)";
      }
    }
    return "(Denegada)";
  };

  return (
    <>
      <div
        className={
          user.rol !== "Invitado"
            ? "row unidad-element animated delay-01s my-3"
            : "row unidad-element animated delay-01s my-3"
        }
        title={
          tipo_unidad_id === 1 && status_id === 1
            ? "Camión"
            : tipo_unidad_id === 7 && status_id === 1
              ? "Caja Seca"
              : tipo_unidad_id === 1 && status_id === 1 && cedi.flujo_id === 2
                ? "Viaje automatico"
                : tipo_unidad_id === 1 && status_id === 2
                  ? "Salida Programada "
                  : "Salida Denegada"
        }
        key={unidad_id}
      >
        <div
          className="col-md-2 text-center pb-3 bordersLeftRounded"
          style={{
            background: "#F5F5F5",
          }}
        >
          <div className="contenedorCarro-salida pt-3">
            <img
              src={
                tipo_unidad_id === 1 && status_id === 1
                  ? carroIcono
                  : tipo_unidad_id === 7
                    ? CajaTp
                    : tipo_unidad_id && status_id === 5
                      ? saveIcono
                      : viajeCreado
              }
              alt=""
              className="img-fluid"
              style={{ inlineSize: "55px" }}
            />
          </div>
        </div>
        <div
          className={`col-6 col-sm-6 text-center ${tipo_unidad_id === 7 ? "" : "cursor"
            }`}
          style={{ heigth: "100%", margin: "auto" }}
          onClick={() => {
            if (tipo_unidad_id === 7) return;

            if (user.rol !== "Invitado") {
              if (cedi.flujo_id && cedi.flujo_id === 2) {
                Swal.fire({
                  icon: "info",
                  title:
                    "¡Esta unidad está en viaje automático no puedes programarle una salida!",
                  showConfirmButton: false,
                  timer: 3000,
                });
              } else {
                selectUnidad(unidad_id);
              }
            }
          }}
        >
          <h6>
            <small>Eco:</small> <b>{unidad_numero} </b>
            &nbsp;
            <small>{cat_tipos_almacen.nombre}:</small>{" "}
            <b>
              {cedi && cedi.nombre_cedis}{" "}
              {spot ? (
                <b className="text-warning">(SPOT {nombre_transportadora})</b>
              ) : (
                ""
              )}
            </b>
            <br />
            {tipo_unidad_id === 1 && (
              <>
                Estatus:{" "}
                <b className="text-warning">
                  {cedi.flujo_id === 2 ? "VIAJE AUTOMÁTICO" : status.nombre}{" "}
                  {status_id === 5 ? pintarMotivoDenegacion(unidad.viajes) : ""}
                </b>
              </>
            )}
          </h6>
        </div>
        <div className="col-2">
          {
            unidad.evento_activo ? (
              <>
                <p
                  style={{ fontSize: "1em", fontWeight: "bold", color: "red", padding: "17px 0px" }}
                >
                  {unidad?.evento_seguridad}
                </p>
              </>
            ) : ""
          }
        </div>
        <div
          className="col-2 text-right d-none d-md-block"
          style={{
            heigth: "100%",
            margin: "auto",
            background: "rgb(245, 245, 245)",
            margin: 0,
            borderRadius: "0px 0.5rem 0.5rem 0px",
            padding: "0px",
            textAlign: "center",
          }}
        >
          {
            (user.roles_id !== 6 && user.roles_id !== 8) && (
              <>
                <div className="row">
                  {
                    unidad.evento_activo === 0 ? (
                      <>
                        <div className="col-2">
                          <a
                            style={{
                              fontSize: "25px",
                              position: "relative",
                              top: "24px",
                              color: "rgb(46 51 59)",
                              cursor: "pointer",
                            }}
                            onClick={
                              () => {
                                setActiModal(true);
                                setUnidadSeleccionada(unidad);
                              }
                            }
                          >
                            <FontAwesomeIcon title="Registro de evento de seguridad" icon={faUserSecret} />
                          </a>
                        </div>
                        <div className="col-10">
                          <TarjetaAperturaUnidad unidad_id={unidad_id} comandos={comandos} />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-12">
                          <TarjetaAperturaUnidad unidad_id={unidad_id} comandos={comandos} />
                        </div>
                      </>
                    )
                  }

                </div>
              </>
            )
          }
        </div>
      </div>

      {
        actiModal &&
        <GestionEventoRoboCamionesModal
          isOpen={actiModal}
          onClose={() => modalClose(false)}
          onConfirm={() => modalClose(false)}
          unidad={unidadSeleccionada}
          eventAction={eventAction}
        // refreshData={refreshData}
        />
      }

    </>
  );
};
